/**
 * Global console-logging switches shared across every BizFirst app/package that touches
 * login/session code.
 *
 * Lives in `@passport/api-client`, not per-app, because this package is already a direct
 * dependency of every app and package involved in the cross-app login/handoff flow (the login
 * app at localhost:8001, saas-tenant-administration at localhost:6102, `@passport/store`,
 * `@passport/auth`, etc. — verified by reading each one's package.json before picking this
 * location). `@passport/store` itself depends on `@passport/api-client` (imports
 * `AuthClient`/`HttpClient` from it), so defining the flag down here — instead of in
 * `@passport/store` — avoids a circular-dependency risk while still letting every consumer reach
 * it via a single import path. One flag, flip once here, and every app that imports it (directly
 * or by re-export) picks up the change — not a per-app copy that can drift out of sync.
 *
 * DO NOT remove the console.log statements gated behind `enableConsoleLogs.loginProcess` in any
 * future change — toggle them off via this flag instead. They are the primary diagnostic tool
 * for login/session/redirect-loop issues across the login app, the handoff/redeem flow, and every
 * consuming app's own session-adoption code.
 */
export const enableConsoleLogs = {
  /**
   * Logs every step of the login/sign-in flow across every app that participates in it: form
   * submit, each outgoing API call (URL, method, body shape), each response received (status
   * code, body shape), token storage, cross-app handoff issue/redeem, and the redirect decision
   * made at each point (proceed vs. fall back to the login app). Defaults to `true` for now —
   * this is an active debugging session for a login redirect-loop bug — flip to `false` once
   * the investigation is closed out.
   */
  loginProcess: true,
};
